// extracted by mini-css-extract-plugin
export default {"itemMenuIconContainer":"style_itemMenuIconContainer__E4tUD"};